import {getCoralServiceDataFromParent} from "../handler/ParentDataHandler";
import {
    PROCESS_NODE_RESOURCE,
    ENDPOINT_GET_ASSET_BY_ASSET_TYPE,
    ENDPOINT_ADD_ASSET,
    ENDPOINT_UPDATE_ASSET,
    ENDPOINT_SET_ASSET_STATUS, ENDPOINT_GET_ASSET_BY_ASSET_LABEL
} from "../util/Constants";
import {createRequest} from "../util/Util";

/**
 * Fetches an asset by calling appropriate end point.
 *
 * @returns {Promise<*>}
 * @param nodeId
 * @param assetType
 */
export async function getAssets(nodeId, assetType) {
    const requestBody = {
        nodeId: nodeId,
        assetType: assetType
    };
    let args = createRequest(PROCESS_NODE_RESOURCE, ENDPOINT_GET_ASSET_BY_ASSET_TYPE, requestBody);
    return await getCoralServiceDataFromParent(args, PROCESS_NODE_RESOURCE, ENDPOINT_GET_ASSET_BY_ASSET_TYPE);
}

/**
 * Adds asset by calling appropriate end point.
 *
 * @param asset
 * @returns {Promise<*>}
 */
export async function addAsset(asset) {
    let args = createRequest(PROCESS_NODE_RESOURCE, ENDPOINT_ADD_ASSET, {asset: asset});
    return await getCoralServiceDataFromParent(args, PROCESS_NODE_RESOURCE, ENDPOINT_ADD_ASSET);
}

/**
 * Updates asset by calling appropriate end point.
 *
 * @param asset
 * @returns {Promise<*>}
 */
export async function updateAsset(asset) {
    let args = createRequest(PROCESS_NODE_RESOURCE, ENDPOINT_UPDATE_ASSET, {asset: asset});
    return await getCoralServiceDataFromParent(args, PROCESS_NODE_RESOURCE, ENDPOINT_UPDATE_ASSET);
}

/**
 * Deprecate asset by calling appropriate end point.
 *
 * @param assetLabel
 * @param status
 * @returns {Promise<*>}
 */
export async function setAssetStatus(assetLabel, status) {
    const requestBody = {
        assetLabel: assetLabel,
        assetStatus: status
    }
    let args = createRequest(PROCESS_NODE_RESOURCE, ENDPOINT_SET_ASSET_STATUS, requestBody);
    return await getCoralServiceDataFromParent(args, PROCESS_NODE_RESOURCE, ENDPOINT_ADD_ASSET);
}

/**
 * Fetches an asset by calling appropriate end point.
 *
 * @param assetLabel
 * @returns {Promise<*>}
 */
export async function getAssetByAssetLabel(assetLabel) {
    const requestBody = {
        assetLabel: assetLabel
    };
    let args = createRequest(PROCESS_NODE_RESOURCE, ENDPOINT_GET_ASSET_BY_ASSET_LABEL, requestBody);
    return await getCoralServiceDataFromParent(args, PROCESS_NODE_RESOURCE, ENDPOINT_GET_ASSET_BY_ASSET_LABEL);
}



// WEBPACK FOOTER //
// ./src/components/resources/AssetResource.js